




































import {Component, PropSync} from "vue-property-decorator";
import {Action, Getter} from "vuex-class";
import BaseFilter from "@/components/Filter/BaseFilter";
import {BalanceFilter} from "@/store/finance/types";
import {DatePickerWings, FastDateDetailWings, SelectWings} from "wings-ui-components";
import {beginningOfCurrentDay, currentDateEnd, dateFilter} from "@/utils/date-util";

@Component({components: {SelectWings, DatePickerWings, FastDateDetailWings}, filters: {dateFilter}})
export default class BalancesFilter extends BaseFilter<BalanceFilter>{
  @PropSync('show') is_show!: boolean;
  @Action("getBalances") actionGetBalances: any;

  defaultFilter(): BalanceFilter {
    return {
      date_from: beginningOfCurrentDay(),
      date_to: currentDateEnd(),
      source: undefined
    }
  }

  created() {
    this.filtered();
  }

 async onFilteredAction() {
    if (this.filter.date_from && this.filter.date_to) {
      await this.actionGetBalances(this.filter);
      await this.$emit('check-filter-event', true);
    }else {
      this.$emit('check-filter-event', false);
    }
  }
}
